import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSemaphoreciComponent } from './simple-icons-semaphoreci.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSemaphoreciComponent ],
    exports:      [ SimpleIconsSemaphoreciComponent ],
    bootstrap:    []
})
export class SimpleIconsSemaphoreciModule {}
